export default{
  getNotifications(state) {
    return state.notifications
  }
}
